var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifications-container"},_vm._l((_vm.notifications),function(note,index){return _c('el-card',{key:index,staticClass:"notification full-width-card"},[_c('h4',[_vm._v(_vm._s(note.title))]),_c('p',[_vm._v(_vm._s(note.text))]),_c('span',{staticClass:"date"},[_vm._v(_vm._s(note.date))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }